import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

interface UploadResponse {
  success: boolean;
  message: string;
  data?: {
    pdf_url: string;
    booking_id: number;
    document_type: 'collection' | 'delivery';
  };
  errors?: { [key: string]: string[] };
  error?: string;
}

interface TokenVerifyResponse {
  success: boolean;
  message: string;
  data?: {
    booking_id: number;
    expires_at: string;
    email: string;
    collection_uploaded: boolean;
    delivery_uploaded: boolean;
    both_uploaded: boolean;
    is_expired: boolean;
    can_upload: boolean;
  };
  error?: string;
}

@Injectable({
  providedIn: 'root',
})
export class PodUploadService {
  constructor(private http: HttpClient) {}

  verifyToken(token: string): Observable<TokenVerifyResponse> {
    const headers = new HttpHeaders({
      Accept: 'application/json',
    });

    return this.http.get<TokenVerifyResponse>(`${environment.domain}/${environment.apiVersion}/pod-upload/${token}/verify`, { headers });
  }

  getExistingDocument(bookingId: number, documentType: 'collection' | 'delivery', podToken?: string): Observable<Blob> {
    const params: Record<string, string | number> = {
      booking_id: bookingId,
      proof_type: documentType,
    };

    if (podToken) {
      params['pod_token'] = podToken;
    }

    return this.http.get(`${environment.domain}/${environment.apiVersion}/listing/upload-proof/doc-attachments`, {
      params,
      responseType: 'blob',
    });
  }

  uploadFilesWithExisting(token: string, existingFile: File | null, newFiles: File[], documentType: 'collection' | 'delivery'): Observable<UploadResponse> {
    return this.uploadFiles(
      token,
      existingFile
        ? [
            existingFile,
            ...newFiles,
          ]
        : newFiles,
      documentType,
    );
  }

  uploadFiles(token: string, files: File[], documentType: 'collection' | 'delivery'): Observable<UploadResponse> {
    const formData = new FormData();

    files.forEach((file, index) => {
      formData.append(`files[${index}]`, file);
    });

    formData.append('document_type', documentType);

    const headers = new HttpHeaders({
      Accept: 'application/json',
    });

    return this.http.post<UploadResponse>(`${environment.domain}/${environment.apiVersion}/pod-upload/${token}`, formData, { headers });
  }
}
